import * as Sentry from "@sentry/react";

// Initialize Sentry for frontend error tracking
export const initSentry = () => {
  // Only initialize if we have a DSN configured
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      
      // Set environment (development, staging, or production)
      environment: process.env.NODE_ENV || 'development',
      
      // Capture 100% of errors in production, 50% in development
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 1.0 : 0.5,
      
      // ← REMOVED: All integrations that need separate packages
      // Basic error tracking works perfectly without them
      
      // Filter out known non-critical errors
      beforeSend(event, hint) {
        const error = hint.originalException;
        
        // Ignore certain error types
        if (error && typeof error === 'string') {
          // Ignore Firebase auth errors that are expected
          if (error.includes('auth/popup-closed-by-user')) return null;
          if (error.includes('auth/cancelled-popup-request')) return null;
        }
        
        // Send everything else to Sentry
        return event;
      },
    });
    
    console.log('Sentry initialized for frontend');
  } else {
    console.warn('Sentry DSN not configured - error tracking disabled');
  }
};

// Export Sentry for use in components
export { Sentry };